// Menüs ohne Maus (X10): Steuerkreuz, Stick und Pfeiltasten springen zum nächsten Knopf in der Richtung.

const FOCUSABLE = 'button:not([disabled]), input:not([disabled]), select:not([disabled]), [data-nav]';

function visible(el: HTMLElement): boolean {
  const r = el.getBoundingClientRect();
  return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
}

export function focusables(root: HTMLElement): HTMLElement[] {
  return [...root.querySelectorAll<HTMLElement>(FOCUSABLE)].filter(visible);
}

/** Erster sinnvoller Knopf: der Hauptknopf, sonst der erste */
export function focusFirst(root: HTMLElement): void {
  const list = focusables(root);
  const primary = list.find((e) => e.classList.contains('primary')) ?? list[0];
  primary?.focus({ preventScroll: false });
}

/** Zum nächsten Element in Richtung (dx, dy); bleibt der Fokus außerhalb, zum ersten */
export function moveFocus(root: HTMLElement, dx: number, dy: number): void {
  const list = focusables(root);
  if (!list.length) return;
  const cur = document.activeElement as HTMLElement | null;
  if (!cur || !root.contains(cur) || !list.includes(cur)) {
    focusFirst(root);
    return;
  }
  const a = cur.getBoundingClientRect();
  const ax = a.left + a.width / 2;
  const ay = a.top + a.height / 2;
  let best: HTMLElement | null = null;
  let bestScore = Infinity;
  for (const el of list) {
    if (el === cur) continue;
    const b = el.getBoundingClientRect();
    const bx = b.left + b.width / 2;
    const by = b.top + b.height / 2;
    const along = (bx - ax) * dx + (by - ay) * dy;
    if (along <= 2) continue;
    const across = Math.abs((bx - ax) * dy) + Math.abs((by - ay) * dx);
    const score = along + across * 2.5;
    if (score < bestScore) {
      bestScore = score;
      best = el;
    }
  }
  if (best) {
    best.focus();
    best.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
}

/** Aus dem stetigen Stick-Wert einzelne Schritte machen, mit Wiederholung beim Halten */
export function createPulse(): (x: number, y: number, dt: number) => [number, number] | null {
  let held = false;
  let wait = 0;
  return (x, y, dt) => {
    const len = Math.hypot(x, y);
    if (len < 0.5) {
      held = false;
      return null;
    }
    const dir: [number, number] = Math.abs(x) > Math.abs(y) ? [Math.sign(x), 0] : [0, Math.sign(y)];
    if (!held) {
      held = true;
      wait = 0.35;
      return dir;
    }
    wait -= dt;
    if (wait <= 0) {
      wait = 0.12;
      return dir;
    }
    return null;
  };
}
